import { get, put, post } from '../index'
import { IPageParams, IUserCertificationApplyQuery } from '~/typings'

export const EMAIL_NOTIFICATION_STATUS = {
  notSubscribe: '0',
  subscribed: '1',
  cancelSubscribe: '2'
}

export async function getUserById (userId: string) {
  return await get(`/user/getUserById?id=${userId}`)
}
export async function updateUserInfo (payload: any) {
  return await post('/user/update', payload)
}
export async function updateLanguage (payload: any) {
  return await post('/user/updateLanguageId', payload)
}

export async function uploadAvatar (data: File) {
  return await put('/user/image/upload', {
    name: 'image',
    file: data
  })
}

// 用户证书申请
export async function applyCertificate (data: IUserCertificationApplyQuery) {
  return await post('/user/certificationApply/apply', data)
}

// 用户报名实操考试
export async function enrollPracticalExam (data: {
  practicalExamId: number
  allergies?: string
  dietaryRequirements?: string
}) {
  return await post('/user/practicalExamApprove/enroll', data)
}

// 用户的考试和测验
export async function getUserTestList () {
  return await post('/user/getUserExamAndQuizzes')
}

export async function getCourseList (data: {
  pageNum: number
  pageSize: number
  certificationId: number | string
  learningProcess: number | string
}) {
  return await get('/certification/release/my/course', data)
}
export async function getCredits () {
  return await get('/certification/release/my/credits')
}
export async function getCertificationList () {
  return await get('/certification/release/certification/list')
}
// 更新证书过期提醒
export async function updateRemindStatus () {
  return await post('/user/certificationApply/updateWindowRemindStatus')
}
//前台获取配置实物证书的站点
export async function getConfigCertificationSites () {
  return await get('/certification/site/getSitePaperCerStatus')
}
//更新用户实物证书状态
export async function updateUserCertificationStatu (data: { certificationId: number }) {
  return await post('/user/certificationApply/updatePaperCertificate', data)
}
//获取用户订餐历史记录
export async function getLatestOrderInfo () {
  return await post('/user/registration/getLatestOrderingByUserId')
}
// 更新用户是否看过弹窗状态
export async function updateMigrationPopStatus () {
  return await post('/user/updateMigrationPopStatus')
}
// 获取个人中心认证课程
export async function getCourseOfCertification (data: {
  pageNum: number
  pageSize: number
  certificationKeyWord: string
}) {
  return await get('/certification/release/my/courseOfCertification', data)
}
// 获取个人中心个人认证
export async function getCertifications (data: {
  pageNum: number
  pageSize: number
}) {
  return await post('/user/certificationApply/getCertificationsByUserId', data)
}
// 获取个人中心面授课程
export async function getUserClassroomList (data: {
  pageNum: number
  pageSize: number
  userId: number
  classroomName: string
}) {
  return await post('/user/registration/getClassroomByUserId', data)
}
// 获取个人中心非认证课程
export async function getNonCertificateCourseProcess (data: {
  pageNum: number
  pageSize: number
  keyword: string
}) {
  return await post('/user/course/process/getNonCertificateCourseProcess', data)
}
